import script from "./dashboards.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboards.vue?vue&type=script&setup=true&lang=js"

import "./dashboards.vue?vue&type=style&index=0&id=3ab1c35c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab1c35c"]])

export default __exports__